// extracted by mini-css-extract-plugin
export default {"attributeLabelDetailsComponent":"attribute-label-details-component__attribute-label-details-component__OaogJ","buttonDiv":"attribute-label-details-component__button-div__kDW2t"};